import { Location } from '@angular/common';
import { Component, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

interface MenuItem {
  id: string;
  link: string;
  icon: string;
  expandedText: string;
  type?: string;
  options?: MenuItem[];
}

interface MenuConfig {
  title: string;
  menu: MenuItem[];
}

@Component({
  selector: 'sbnb-nested-subnav',
  templateUrl: './nested-subnav.component.html',
  styleUrls: ['./nested-subnav.component.scss']
})
export class NestedSubnavComponent {
  public menu: MenuItem[] = [];
  public title: string = '';
  public id: string = '';
  @Input() iconBase: string = '/assets/iconography/';

  public constructor(
    private route: ActivatedRoute,
    private router: Router,
    public location: Location
  ) { }

  ngOnInit() {
    this.route.data.subscribe(data => {
      const { id, title } = data;
      this.id = id;
      this.title = title;
    });
  }

  back() {
    this.router.navigate(['/menu-mobile']);
  }
}
